



























































































































































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import xlsx from "xlsx";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  ModelConfigCommand,
  ModelConfig,
  ModelConfigData,
} from "@/api/baseDefine";
import {
  SendDataReq,
  sendData,
  meters,
  GetPowerConditionerDataReq,
  getPowerConditionerData,
  PowerConditioner,
  getModelConfigs,
  GetModelConfigsReq,
  updateMeter,
  externalDeviceDatas,
  GetExternalDeviceDataReq,
  datas,
  ExternalDeviceModelData,
} from "@/api/meter";
import { formatDate, formatDateTime } from "../../utils/dateUtil";
@Component
export default class PowerConditionerDialog extends Vue {
  @Prop({ default: null, required: true }) private meters!: Meter[];
  @Watch("meters", { deep: true })
  public onChangeValue(val) {
    console.log("onChangeValue", val);
  }
  // powerConditioner
  private brand: string = "";
  private model: string = "";
  private baudRate: string = "";
  private show: boolean = false;
  private selectCommandIndex: string = "";
  private node: string = "";
  private showBrandNames: string[] = [];
  private isAutoRead: boolean = false;
  private autoReadMin: string = "";
  // 所有的model names
  private ModelNames: string[] = [];
  // 当前的modelNames
  private showModelNames: string[] = [];
  // 列表需要显示的commands
  private showModelCommands: ModelConfigData[] = [];
  private baudRates: string[] = [];
  private fixedBaudRates: string[] = [];
  private nodes: string[] = [];

  private tableData: PowerConditionerTableData[] = [];
  private modelConfig: ModelConfig = <ModelConfig>{};
  // 列表的名字
  private Model1DataItems: string[] = [];
  private Model2DataItems: string[] = [];
  private Model3DataItems: string[] = [];
  private ModelHuaweiDataItems: string[] = [];
  private VBPC244GM2SDataItems: string[] = [];
  private ModelIILDataItems: string[] = [];
  private exportTime = "";
  private dialogExport = false;
  private clickShow() {
    this.exportTime = "";
    this.dialogExport = false;
    if (this.meters.length != 1) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.onlyOneMeterSupport").toString(),
        type: "warning",
      });
      return;
    }

    console.log("clickShow", this.meters[0]);
    let whiteMeterIds = [5, 2, 6, 7];
    let verify = false;
    for (let id of whiteMeterIds) {
      if (this.meters[0].meterTypeID == id) {
        verify = true;
      }
    }
    if (!verify) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t(
          "powerConditioner.onlyPvMeterCanHandlePowerConditioner"
        ).toString(),
        type: "warning",
      });
      return;
    }
    this.show = true;
    this.isAutoRead = this.meters[0].isExternalDeviceAutoRead;
    this.autoReadMin = this.meters[0].externalDeviceAutoReadMinute;
  }

  private created() {
    this.initData();
    this.getPowerConditionerData(true);
  }
  private onDialogChange(v) {
    console.log("onDialogChange", v, this.show);
  }
  /**
   * 选择品牌的回调
   */
  private onSelectBrand() {
    let brandIndex = Number(this.brand);
    console.log("onSelectBrand", this.brand, brandIndex);
    this.showModelCommands = [];
    if (!!this.model) {
      this.model = "";
    }
    this.selectCommandIndex = "";
    this.baudRate = "";
    this.node = "";
    if (brandIndex <= 0) {
      this.showModelNames = this.ModelNames.slice(0, 2);
    } else if (brandIndex == 1) {
      this.showModelNames = this.ModelNames.slice(2, 3);
    } else if (brandIndex == 2) {
      this.showModelNames = this.ModelNames.slice(3, 4);
    } else if (brandIndex == 3) {
      this.showModelNames = this.ModelNames.slice(4, 5);
    } else if (brandIndex == 4) {
      this.showModelNames = this.ModelNames.slice(5, 6);
    }
  }

  private getModelConfigCommandFromModelConfig(
    modelConfig: ModelConfig,
    modelType: number
  ): ModelConfigCommand {
    for (let command of modelConfig.commands) {
      if (command.type == modelType) {
        return command;
      }
    }
    return <ModelConfigCommand>{};
  }

  /**
   * 查找
   */
  private async getModelConfig(modelType: number): Promise<ModelConfigCommand> {
    if (!!this.modelConfig.commands && this.modelConfig.commands.length > 0) {
      // empty
    } else {
      let req = <GetModelConfigsReq>{};
      let res = await getModelConfigs(req);
      if (res.code == ResCode.SUCCESS) {
        console.log("getModelConfig---------->", res.data);
        this.modelConfig = res.data.modelConfig;
      }
    }
    if (!this.modelConfig.commands || this.modelConfig.commands.length == 0) {
      return <ModelConfigCommand>{};
    }
    let command: ModelConfigCommand = this.getModelConfigCommandFromModelConfig(
      this.modelConfig,
      modelType
    );
    return command;
  }
  /**
   * 选择model的回调
   */
  private async onSelectModel() {
    console.log("onSelectModel", this.model);
    let modelIndex = this.ModelNames.indexOf(this.model);
    let tempContents: string[] = [];
    this.selectCommandIndex = "";
    this.baudRate = "";
    this.node = "";
    let modelConfigCommand: ModelConfigCommand = await this.getModelConfig(
      modelIndex
    );
    this.showModelCommands = modelConfigCommand.commands;
    console.log(modelConfigCommand);
    console.log(this.showModelCommands);

    let tempIndex: string[] = modelConfigCommand.modelIndexs;
    this.baudRates = modelConfigCommand.baudRates;
    if (modelIndex == 0) {
      tempContents = this.Model1DataItems;
      this.generateNodes(0, 31);
    } else if (modelIndex == 1) {
      tempContents = this.Model2DataItems;
      this.generateNodes(0, 31);
    } else if (modelIndex == 2) {
      tempContents = this.Model3DataItems;
      this.generateNodes(0, 247);
    } else if (modelIndex == 3) {
      tempContents = this.ModelHuaweiDataItems;
      this.generateNodes(0, 247);
    } else if (modelIndex == 4) {
      tempContents = this.VBPC244GM2SDataItems;
      this.generateNodes(1, 31);
    } else if (modelIndex == 5) {
      tempContents = this.ModelIILDataItems;
      this.generateNodes(1, 31);
    }
    this.tableData = [];

    for (let i = 0; i < tempIndex.length; i++) {
      let d: PowerConditionerTableData = <PowerConditionerTableData>{};
      d.index = tempIndex[i];
      d.content = tempContents[i];
      this.tableData.push(d);
    }
    this.getPowerConditionerData(false);
  }

  /**
   * 选择命令的回调
   */
  private onSelectCommand() {
    console.log("onSelectCommand", this.selectCommandIndex);
  }

  private onSelectNode() {
    console.log("onSelectNode", this.node);
  }

  public async sendPowerConditioner() {
    this.realSendPowerConditionerToModel();
  }

  public async onAutoReadChange() {
    console.log(this.isAutoRead, this.autoReadMin);
    let reqMeter = <Meter>{};
    reqMeter.id = this.meters[0].id;
    reqMeter.isExternalDeviceAutoRead = this.isAutoRead;
    reqMeter.externalDeviceAutoReadMinute = this.autoReadMin;
    console.log(this.selectCommandIndex, this.node);
    let modelIndex = this.ModelNames.indexOf(this.model);
    if (!this.checkSendPowerConditioner()) {
      return;
    }
    let baudIndex = this.fixedBaudRates.indexOf(this.baudRate) + 1;
    if (modelIndex == 5) {
      reqMeter.externalDeviceAutoReadParam =
        "0000," + this.node + ",7," + baudIndex + "," + 5;
    }
    reqMeter.id = this.meters[0].id;
    const res = await updateMeter(reqMeter);
  }
  /**
   * 发送逆变器相关的命令
   */
  private async realSendPowerConditionerToModel() {
    console.log(this.selectCommandIndex, this.node);
    let modelIndex = this.ModelNames.indexOf(this.model);
    if (!this.checkSendPowerConditioner()) {
      return;
    }
    let baudIndex = this.fixedBaudRates.indexOf(this.baudRate) + 1;
    let numberOdParamer =
      this.showModelCommands[Number(this.selectCommandIndex)].paramNumber;
    let typeAndAdreess =
      this.showModelCommands[Number(this.selectCommandIndex)].startAddress;

    console.log("sendPowerConditioner", this.meters);
    let req: SendDataReq = <SendDataReq>{};
    let param0 = typeAndAdreess.replace("-", "");
    let param1 = this.node;
    console.log("sendPowerConditioner param1 length", param1.length);
    if (param1.length == 1) {
      param1 = "0" + param1;
    }

    // param0是address  param1 是node  param2是（paramer count 或者 count）
    req.params =
      param0 +
      "," +
      param1 +
      "," +
      numberOdParamer +
      "," +
      baudIndex +
      "," +
      modelIndex;
    req.meterIDs = this.getMeterIDs();
    req.dataType = 8;
    console.log("sendPowerConditioner req:", req);
    const res = await sendData(req);
    if (res.code === ResCode.SUCCESS) {
      // this.dialogBatchWrite = false;
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.dataPackageSendSuccess").toString(),
        type: "success",
      });
    } else {
      let codeStr = String(res.code);
      console.log("getPowerConditionerData codeStr:", codeStr, res.code);
      let errorMsg = this.$t("ErrorMsg");
      if (!!errorMsg[codeStr]) {
        this.$notify({
          title: this.$t("common.warning").toString(),
          message: errorMsg[codeStr],
          type: "warning",
        });
      }
    }
  }

  private async getPowerConditionerData(loop: boolean) {
    if (loop) {
      setTimeout(() => {
        this.getPowerConditionerData(true);
      }, 4 * 1000);
    }
    if (!this.show) {
      return;
    }
    if (!this.model) {
      return;
    }
    console.log("getPowerConditionerData start");
    let modelIndex = this.ModelNames.indexOf(this.model);
    let meterID = this.meters[0].meterID;
    let req: GetPowerConditionerDataReq = <GetPowerConditionerDataReq>{};
    req.model = modelIndex;
    req.meterID = meterID;
    const res = await getPowerConditionerData(req);

    if (res.code === ResCode.SUCCESS) {
      let powerConditioners: PowerConditioner[] = res.data.datas;
      this.updatePowerConditionerMap(powerConditioners);
    }
  }
  private powerConditionerMap: Map<string, PowerConditioner> = new Map();

  /**
   * 更新map
   */
  private updatePowerConditionerMap(powerConditioners: PowerConditioner[]) {
    console.log(
      "updatePowerConditionerMap tableData:",
      this.tableData,
      "powerConditioners:",
      powerConditioners
    );
    this.powerConditionerMap = new Map();
    for (let powerConditioner of powerConditioners) {
      if (powerConditioner.modelType < 2) {
        let type = powerConditioner.typeAndAddress.slice(0, 2);
        let address = powerConditioner.typeAndAddress.slice(2, 6);
        this.powerConditionerMap[type + "-" + address] = powerConditioner;
      } else if (powerConditioner.modelType == 2) {
        this.powerConditionerMap[powerConditioner.typeAndAddress] =
          powerConditioner;
      } else if (powerConditioner.modelType == 3) {
        this.powerConditionerMap[powerConditioner.index] = powerConditioner;
      } else if (powerConditioner.modelType == 5) {
        this.powerConditionerMap[
          "0x" + powerConditioner.typeAndAddress.toUpperCase()
        ] = powerConditioner;
      } else {
        this.powerConditionerMap[powerConditioner.index] = powerConditioner;
      }
    }
    for (let i = 0; i < this.tableData.length; i++) {
      let t = this.tableData[i];
      let powerData: PowerConditioner =
        this.powerConditionerMap[t.index.toString()];
      if (!powerData) {
        t.data = "";
        t.lastTime = "";
        t.responseCode = "";
        this.$set(this.tableData, i, t);
        continue;
      }
      this.convertValue(powerData);
      t.data = powerData.value;
      t.lastTime = powerData.time;
      t.responseCode = powerData.respondCode;
      this.$set(this.tableData, i, t);
    }
  }

  private convertValue(powerData: PowerConditioner) {
    if (powerData.typeAndAddress == "C2-0200") {
      powerData.value =
        powerData.value.slice(0, 2) +
        "-" +
        powerData.value.slice(2, 3) +
        "." +
        powerData.value.slice(3, 4);
    }
    if (!powerData.time) {
      powerData.time = formatDateTime(new Date(powerData.timestamp * 1000));
    }
    if (powerData.value == "error") {
      powerData.value = "";
    }
    powerData.value = powerData.value + " " + powerData.unit;
  }

  public async clearForm() {
    if (!this.model) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.selectModel").toString(),
        type: "warning",
      });
      return;
    }
    let modelIndex = this.ModelNames.indexOf(this.model);
    let req: SendDataReq = <SendDataReq>{};
    req.dataType = -1;
    req.params = modelIndex + "";
    let meterIDS: {
      meterID: string;
      meterTypeID: number;
    }[] = [];
    for (let item of this.meters) {
      let meterID: {
        meterID: string;
        meterTypeID: number;
      } = {
        meterID: item.meterID,
        meterTypeID: item.meterTypeID,
      };
      meterIDS.push(meterID);
    }
    req.meterIDs = meterIDS;
    console.log("sendPowerConditioner req:", req);
    const res = await sendData(req);
    if (res.code === ResCode.SUCCESS) {
      // this.dialogBatchWrite = false;
      this.getPowerConditionerData(false);
      // this.$notify({
      //   title: this.$t("common.success").toString(),
      //   message: this.$t("notification.dataPackageSendSuccess").toString(),
      //   type: "success"
      // });
    }
  }

  private initData() {
    let brandNames = this.$t("brandNames") as any;
    for (let item of brandNames) {
      this.showBrandNames.push(item);
    }
    let ModelNames = this.$t("ModelNames") as any;
    for (let item of ModelNames) {
      this.ModelNames.push(item);
    }
    let Model1DataItems = this.$t("Model1DataItems") as any;
    for (let item of Model1DataItems) {
      this.Model1DataItems.push(item);
    }

    let Model2DataItems = this.$t("Model2DataItems") as any;
    for (let item of Model2DataItems) {
      this.Model2DataItems.push(item);
    }

    let Model3DataItems = this.$t("Model3DataItems") as any;
    for (let item of Model3DataItems) {
      this.Model3DataItems.push(item);
    }
    let ModelHuaweiDataItems = this.$t("ModelHuaweiDataItems") as any;
    for (let item of ModelHuaweiDataItems) {
      this.ModelHuaweiDataItems.push(item);
    }

    let VBPC244GM2SDataItems = this.$t("VBPC244GM2SDataItems") as any;
    for (let item of VBPC244GM2SDataItems) {
      this.VBPC244GM2SDataItems.push(item);
    }
    let ModelIILDataItems = this.$t("ModelIILDataItems") as any;
    for (let item of ModelIILDataItems) {
      this.ModelIILDataItems.push(item);
    }

    this.fixedBaudRates = [
      "2400",
      "4800",
      "9600",
      "19200",
      "38400",
      "115200",
      "153600",
    ];
  }

  private generateNodes(start: number, end: number) {
    this.nodes = [];
    for (let i = start; i <= end; i++) {
      let is = "";
      if (i < 10) {
        is = "0" + i;
      } else {
        is = i.toString();
      }
      this.nodes.push(is);
    }
  }

  private checkSendPowerConditioner(): boolean {
    // if (this.selectCommandIndex == "") {
    //   this.$notify({
    //     title: this.$t("common.warning").toString(),
    //     message: this.$t("powerConditioner.selectCommand").toString(),
    //     type: "warning",
    //   });
    //   return false;
    // }
    if (!this.node) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.selectNode").toString(),
        type: "warning",
      });
      return false;
    }
    if (!this.baudRate) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("powerConditioner.inputBaudRate").toString(),
        type: "warning",
      });
      return false;
    }
    return true;
  }

  private getMeterIDs() {
    let meterIDS: {
      meterID: string;
      meterTypeID: number;
    }[] = [];
    for (let item of this.meters) {
      let meterID: {
        meterID: string;
        meterTypeID: number;
      } = {
        meterID: item.meterID,
        meterTypeID: item.meterTypeID,
      };
      meterIDS.push(meterID);
    }
    return meterIDS;
  }

  public async exportData() {
    let d = this.exportTime;
    if (!this.exportTime) {
      this.$notify({
        title: this.$t("common.warning").toString(),
        message: this.$t("notification.inputIllegal").toString(),
        type: "warning",
      });
      return;
    }
    let startTime = Math.floor(new Date(d[0]).getTime() / 1000);
    let endTime = Math.floor(new Date(d[1]).getTime() / 1000);
    let meterID = this.meters[0].meterID;
    let req: GetExternalDeviceDataReq = <GetExternalDeviceDataReq>{};
    req.startTime = startTime;
    req.endTime = endTime;
    req.meterID = meterID;
    req.modelIndex = [];
    if (!!this.model) {
      let modelIndex = this.ModelNames.indexOf(this.model);
      req.modelIndex.push(modelIndex);
    } else {
      for (let i = 0; i < this.ModelNames.length; i++) {
        req.modelIndex.push(i);
      }
    }

    const res = await externalDeviceDatas(req);
    if (res.code === ResCode.SUCCESS && !!res.data) {
      this.dialogExport = false;
      let externalDeviceModelDatas = res.data.externalDeviceModelDatas;
      if (!!externalDeviceModelDatas && externalDeviceModelDatas.length > 0) {
        for (let i = 0; i < externalDeviceModelDatas.length; i++) {
          await this.export(
            meterID,
            startTime,
            endTime,
            externalDeviceModelDatas[i]
          );
        }
      } else {
        this.$notify({
          title: this.$t("common.success").toString(),
          message: this.$t("notification.DateRangeHaveNoData").toString(),
          type: "success",
        });
      }
    }
  }

  private async export(
    meterID: string,
    startTime: number,
    endTime: number,
    externalDeviceModelData: ExternalDeviceModelData
  ) {
    if (!!datas && datas.length > 0) {
      let json: any = [];
      for (let data of externalDeviceModelData.datas) {
        if (!data || data == "null") {
          continue;
        }
        let j = JSON.parse(data);
        json.push(j);
      }
      json.sort(function (a, b) {
        if (a.Timestamp > b.Timestamp) {
          return -1;
        } else {
          return 1;
        }
      });
      let ss = xlsx.utils.json_to_sheet(json, null); //通过工具将json转表对象
      let ref = ss["!ref"];
      // let keys = Object.keys(ss).sort(); //排序 [需要注意，必须从A1开始]
      // let ref = keys[1] + ":" + keys[keys.length - 1]; //这个是定义一个字符串 也就是表的范围[A1:C5]
      let workbook = {
        //定义操作文档
        SheetNames: ["nodejs-sheetname"], //定义表明
        Sheets: {
          "nodejs-sheetname": ss, //表对象[注意表明]
        },
      };
      xlsx.writeFile(
        workbook,
        meterID +
          "_" +
          Math.floor(Date.now() / 1000) +
          ":" +
          formatDate(new Date(startTime * 1000)) +
          "_" +
          formatDate(new Date(endTime * 1000)) +
          ".xls",
        null
      ); //将数据写入文件
    }
  }
  /**
   * 生成index
   */
  private generateIndexByNumber(
    startIndex: number,
    endIndex: number
  ): string[] {
    let ss: string[] = [];
    for (let i = startIndex; i <= endIndex; i++) {
      ss.push(i.toString());
    }
    return ss;
  }
}
